import styled from "styled-components";
import { Container, CommonImage } from "../../styledComponents/common";

export const AttendanceTableContainer = styled(Container)`
  padding-bottom: 20px;
  overflow-x: auto;
  width: 100%;
`;

export const ClockInOutTableHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1.2fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 1.4fr 1.2fr;
  grid-column-gap: 12px;
  justify-content: start;
  padding: 0 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.secondary};
  min-width: 900px;
`;

export const ClockInOutTableRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1.2fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 1.4fr 1.2fr;
  grid-column-gap: 12px;
  justify-content: start;
  padding: 0 20px;
  min-width: 900px;
  :nth-of-type(even) {
    background-color: #f8f9fc;
  }
`;
export const ClockInOutTableHeaderNew = styled.div`
  display: grid;
  grid-template-columns: 200px 300px;
  grid-column-gap: 20px;
  justify-content: start;
  padding: 0 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.secondary};
  /* @media (max-width: 1250px) {
    grid-template-columns: 250px 200px 200px 150px;
    grid-column-gap: 10px;
  } */
`;

export const SelfieImage = styled(CommonImage)`
  height: 60px;
  margin: -10px 0;
  cursor: pointer;
  &:hover {
    transform: scale(1.5);
    transition: transform 0.1s linear;
  }
`;
